export default function scrollBehavior(to, from, savedPosition) {
  // vào trang product detail thì scroll về đầu trang
  if (to.name && to.name.toLowerCase().includes('product')) {
    return { x: 0, y: 0 };
  }

  // Otherwise, use saved position when using back/forward buttons
  if (savedPosition) {
    return savedPosition;
  }

  // Default - scroll to top
  return { x: 0, y: 0 };
}
